import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { CompleteActionItemBanner } from 'Components/ComponentLibrary/Organisms/CompleteActionItemBanner';
import PageHeader from 'Components/ComponentLibrary/Molecules/PageHeader';
import { FDContentContainer } from '@facet-wealth/design';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { useModalContextSubmissionSuccessful, useRefreshModalCollectionCleared } from 'Hooks/useRefreshEvent';
import { HouseholdProfileBreadcrumbs } from 'Components/ComponentLibrary/Organisms/HouseholdProfileBreadcrumbs';
import { ManageHouseholdMembers } from './ManageHouseholdMembers';

export const ProfilePageMDC = ({ resource }) => {
  const { loadPageContentLink, refreshPageContentCollection } = usePageContentContext();
  const { loadModalCollectionByLink, clearModalCollection } = useModalContext();
  useBoneBackgroundColor();

  useModalContextSubmissionSuccessful((evt, clearModalCollectionDependency) => {
    clearModalCollectionDependency();
  }, [clearModalCollection]);

  useRefreshModalCollectionCleared(() => {
    refreshPageContentCollection();
  });

  return (
    <>
      <CompleteActionItemBanner resource={resource} />
      <FDContentContainer maxWidth={'xl'}>
        <PageHeader
          breadcrumbs={<HouseholdProfileBreadcrumbs resource={resource} onClickBreadcrumb={(link) => loadPageContentLink(link)} />}
          title={resource.attr('title')}
          subtitle={resource.attr('subtitle')}
        />
        <ManageHouseholdMembers
          addMemberRelationship={resource.withRelationship(fr.relationships.addHouseholdMember.name, (rel) => rel, () => null)}
          onAddMember={(rel) => loadModalCollectionByLink(rel.link('related').url())}
          membersCollection={resource.attr('members')}
          refreshMembers={refreshPageContentCollection}
        />
      </FDContentContainer>
    </>
  );
};

ProfilePageMDC.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
